import { gql } from "@apollo/client";

export const CREATE_INTERVENTION = gql`
	mutation CreateIntervention($input: InterventionCreate) {
		createIntervention(input: $input) {
			_id
			technicianId
			machineId
			startedAt
			type
			obs
			photosTaken
		}
	}
`;
